import { render } from "./Travel.vue?vue&type=template&id=d74cd7e8"
import script from "./Travel.vue?vue&type=script&lang=js"
export * from "./Travel.vue?vue&type=script&lang=js"

import "./Travel.vue?vue&type=style&index=0&id=d74cd7e8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__